import React from 'react';
import moment from 'moment';
import thermalComfortEs from '@/assets/img/thermalComfortEs.png';
import thermalComfortEn from '@/assets/img/thermalComfortEn.png';
import * as S from './styles';

export function ThermalComfortImage(): JSX.Element {
	const locale = moment.locale();

	if (locale === 'en') {
		return (
			<S.ThermalComfortContainer>
				<S.ThermalComfortImage src={thermalComfortEn} alt="Thermal Comfort Chart" />
				<S.CustomText>Comfort curves (P.O Fanger, 1972)</S.CustomText>
			</S.ThermalComfortContainer>
		);
	}

	return (
		<S.ThermalComfortContainer>
			<S.ThermalComfortImage src={thermalComfortEs} alt="Thermal Comfort Chart" />
			<S.CustomText>Comfort curves (P.O Fanger, 1972)</S.CustomText>
		</S.ThermalComfortContainer>
	);
}
